<!-- =========================================================================================
  File Name: View.vue
  Description: Device View page
========================================================================================== -->

<template>
  <div id="page-device-view">

    <vs-alert color="danger" title="Устройство не найдено" :active.sync="device_not_found">
      <span>Устройство с идентификатором: {{ $route.params.deviceId }} не найдено. </span>
      <span>
        <span>Перейти в </span><router-link :to="{name:'apps-devices-list'}" class="text-inherit underline">список устройств</router-link>
      </span>
    </vs-alert>

    <div id="device-data" v-if="!device_not_found">

      <vx-card class="mb-base">

        <!-- Logo -->
        <div class="vx-row">

          <!-- Logo Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <img :src="require(`@/assets/images/device/small/device-${deviceData.type ? deviceData.type: 0}.png`)" :alt="deviceData.type_str" class="responsive">
            </div>
          </div>



          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td>
                  <h1>{{ deviceData.type_str }}</h1>
                </td>
                <td>
                  <div class="vx-row">
                    <vs-chip class="status-chip mr-2" :color="deviceData.enable ? 'success' : 'danger'">
                      <span>{{ deviceData.enable ? 'разрешен' : 'запрещен' }}</span>
                    </vs-chip>
                    <vs-chip class="status-chip" :color="deviceData.online ? 'success' : 'danger'">
                      <span>{{ deviceData.online ? 'подключен' : 'не подключен' }}</span>
                    </vs-chip>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Произв. номер MN</td>
                <td>{{ deviceData.did || '-' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Серийный номер SN</td>
                <td>{{ deviceData.ident || '-' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Версия HW</td>
                <td>{{ deviceData.version || '-' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Время cоздания</td>
                <td>{{ deviceData.create_time || '-' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Время подключения</td>
                <td>{{ deviceData.connection_time || '-' }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-bold"><h3>Активация</h3></td>
                <td>
                  <vs-chip class="status-chip" :color="deviceData.activate ? 'success' : 'danger'">
                    <span>{{ deviceData.activate ? 'выполнена' : 'не выполнена' }}</span>
                  </vs-chip>
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Пользователь</td>
                <td>-- (переход на пользователя)</td>
              </tr>
              <tr>
                <td class="font-semibold">Объект</td>
                <td>-- (переход на объект)</td>
              </tr>
              <tr>
                <td class="font-semibold">SIM-карта</td>
                <td>{{ deviceData.number|sim }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Время активации</td>
                <td>{{ deviceData.activate_time || '-' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Гарантии осталось</td>
                <td>{{ deviceData.warranty_time|warranty }}</td>
              </tr>
            </table>
          </div>
          
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex mt-5" id="account-manage-buttons">

            <vs-button icon-pack="feather" icon="icon-list" class="mr-4" :to="{name: 'apps-devices-list'}">Назад к списку</vs-button>

            <vs-button type="border" color="primary" icon-pack="feather" icon="icon-refresh-cw" class="mr-4" @click="updateDevice">Обновить</vs-button>

            <vs-button type="border" color="success" icon-pack="feather" icon="icon-check" class="mr-4" @click="confirmEnableDevice">Разрешить</vs-button>

            <vs-button type="border" color="danger" icon-pack="feather" icon="icon-x" class="mr-4" @click="confirmDisableDevice">Запретить</vs-button>

            <vs-button type="border" color="danger" icon-pack="feather" icon="icon-power" class="mr-4" @click="confirmDisconnectDevice">Отключить</vs-button>
            
          </div>

        </div>

      </vx-card>


    <div class="vx-card p-6">

        <div class="vx-row">
          <vs-checkbox class="check-enable" v-model="checkFrom">от</vs-checkbox>
          <flat-pickr class="datetime-input flatpickr-input" :config="configdateTimePicker" v-model="datetimeFrom" placeholder="От" />
          <vs-checkbox class="check-enable" v-model="checkTo">до</vs-checkbox>
          <flat-pickr class="datetime-input flatpickr-input" :config="configdateTimePicker" v-model="datetimeTo" placeholder="До" />

          <vs-input-number v-model="dataCount"/>
          <vs-checkbox class="check-enable" v-model="checkCount">кол-во</vs-checkbox>
          <vs-checkbox class="check-enable" v-model="checkReverse">реверс</vs-checkbox>
          <vs-checkbox class="check-enable" v-model="checkSortServer">сорт.серв.</vs-checkbox>
          <div class="vx-col flex-shrink">
            <vs-button type="border" color="primary" icon-pack="feather" icon="icon-refresh-cw" class="mr-4" @click="updateDeviceLog">Обновить</vs-button>
          </div>
        </div>

        <div class="vx-row">

          <!-- ITEMS PER PAGE -->
          <div class="vx-col flex-grow">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ deviceLog.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : deviceLog.length }} of {{ deviceLog.length }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>

                <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>


          <vs-button type="border" color="danger" icon-pack="feather" icon="icon-x" class="р-30 vx-col flex-shrink" @click="confirmDeleteDeviceLog">Удалить</vs-button>


          <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input class="vx-col flex-shrink mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Поиск..." />
          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

        </div>


          <!-- :components="components" -->
        <!-- AgGrid Table -->
        <ag-grid-vue
          ref="agGridTable"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="deviceLog"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :floatingFilter="false"
          :pagination="true"
          :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true"
          :enableRtl="$vs.rtl">
        </ag-grid-vue>

        <vs-pagination
          :total="totalPages"
          :max="7"
          v-model="currentPage" />

      </div>


    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import moduleDevice from '@/store/device/moduleDevice.js'
import moment from 'moment'

// Cell Renderer
import CellRendererPayload from "./CellRendererPayload.vue"

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import { Russian } from "flatpickr/dist/l10n/ru.js"

export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererPayload,

    flatPickr
  },
  data() {
    return {
      device_not_found: false,

      searchQuery: "",

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        suppressMovable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'LID',
          field: 'lid',
          width: 160,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: 'Время сервера',
          field: 'server_time',
          width: 195,
        },
        {
          headerName: 'Время устройства',
          field: 'device_time',
          width: 195,
        },
        {
          headerName: 'Индекс',
          field: 'indx',
          width: 110,
        },
        {
          headerName: 'Topic',
          field: 'topic',
          width: 100,
        },
        {
          headerName: 'Payload',
          field: 'payload',
          filter: true,
          width: 1200,
          cellRendererFramework: 'CellRendererPayload'
        },
      ],
      // Cell Renderer Components
      components: {
        CellRendererPayload,
      },
      // datetimeFrom: new Date(),
      // datetimeTo: new Date(),
      datetimeFrom: null,
      datetimeTo: null,

      checkFrom: false,
      checkTo: false,
      dataCount: 50,
      checkCount: true,
      checkReverse: true,
      checkSortServer: false,

      configdateTimePicker: {
        locale: Russian,
        enableTime: true,
        enableSeconds: true,
        dateFormat: 'U',
        disableMobile: true,
        // defaultDate: new Date(),
        defaultHour: 0,
        defaultMinute: 0,
        altFormat: 'd-m-Y H:i:S',
        altInput: true,
      },

    }
  },
  computed: {
    deviceData() {
      return this.$store.state.device.device
    },
    deviceLog() {
      return this.$store.state.device.log
    },
    paginationPageSize() {
      if(this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if(this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  // при выборе даты и времени (от или до) - устанавливать соответствующую галочку
  methods: {
    confirmDeleteDeviceLog() {
      if (this.gridApi.getSelectedRows().length) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Удаление сообщений`,
          text: `Вы действительно хотите удалить все выделенные сообщения?`,
          accept: this.deleteDeviceLog,
          acceptText: "Удалить",
          cancelText: "Отмена"
        })
      } else {
        this.$vs.dialog({
          color: 'primary',
          title: `Удаление сообщений`,
          text: `Выберите из списка сообщения, которые хотите удалить.`,
          acceptText: "Ок",
        })
      }
    },
    deleteDeviceLog() {
      this.$store.dispatch("device/deleteDeviceLog", this.gridApi.getSelectedRows())
      .then(() => {
        this.updateDevice()
      })
    },
    confirmDisconnectDevice() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Отключение устройства`,
        text: `Вы действительно хотите отключить устройство от сети?`,
        accept: this.disconnectDevice,
        acceptText: "Отключить",
        cancelText: "Отмена"
      })
    },
    disconnectDevice() {
      this.$store.dispatch("device/disconnectDevices", [{ did: this.$route.params.deviceId }])
      .then(() => {
        this.updateDevice()
      })
    },
    confirmEnableDevice() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: `Разрешение для устройства`,
        text: `Вы действительно хотите установить разрешение для устройства?`,
        accept: this.enableDevice,
        acceptText: 'Разрешить',
        cancelText: "Отмена"
      })
    },
    confirmDisableDevice() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Запрет для устройства`,
        text: `Вы действительно хотите установить запрет для устройства?`,
        accept: this.disableDevice,
        acceptText: 'Запретить',
        cancelText: "Отмена"
      })
    },
    enableDevice() {
      this.$store.dispatch('device/enableDevices', [{ did: this.$route.params.deviceId }])
      .then(() => {
        this.updateDevice()
      })
    },
    disableDevice() {
      this.$store.dispatch('device/disableDevices', [{ did: this.$route.params.deviceId }])
      .then(() => {
        this.updateDevice()
      })
    },
    updateDevice() {
      this.$store.dispatch("device/fetchDevice", { did: this.$route.params.deviceId })
        .then(() => {
          this.device_not_found = !this.deviceData.did
        })
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    updateDeviceLog() {
      let params = {did: this.$route.params.deviceId};
      if (this.checkFrom) params.date1 = +this.datetimeFrom
      if (this.checkFrom) params.date2 = +this.datetimeTo
      if (this.checkCount) params.count = this.dataCount
      if (this.checkSortServer) params.sort = 'server'
      params.reverse = this.checkReverse

      console.log('this.datetimeFrom', this.datetimeFrom)

      console.log('params', params)

      this.$store.dispatch("device/logDevice", params)
      .then(() => {
        this.updateSearchQuery(this.searchQuery)
      })
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if(this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container")
      header.style.left = "-" + String(Number(header.style.transform.slice(11,-3)) + 9) + "px"
    }
  },
  created() {
    if (!moduleDevice.isRegistered) {
      this.$store.registerModule('device', moduleDevice)
      moduleDevice.isRegistered = true
    }
    this.updateDevice()
    this.updateDeviceLog()

  },
  filters: {
    sim: function (value) {
      return value ? value : '--'
    },
    warranty: function (value) {
        if (typeof value !== 'undefined' && value) {
          return (366 - Math.round((moment() - moment(value)) / 60 / 60 / 24 / 1000)) + ' дн.'
        }
        return "-"
    },
    network_status: function (value) {
      return value ? 'в сети' : 'не в сети'
    },
    sectime: function (seconds) {
      let hide_sec = false;
      let time = '';
      let years = 0;
      let days = 0;
      let hours = 0;
      let mins = 0;
      if (seconds >= 60) {
        if (seconds >= 3600) {
          if (seconds >= 86400) {

            if (seconds >= 31536000) {
              years = parseInt(seconds / 31536000);
              seconds -= years * 31536000;
              let l = years.toString().slice(-1);
              if (l == 1) {
                time += years + ' год ';
              } else if (l > 0 && l < 5) {
                  time += years + ' года ';
              } else {
                time += years + ' лет ';
              }
            }
            days = parseInt(seconds / 86400);
            seconds -= days * 86400;
            let l = days.toString().slice(-1);
            if (days == 0) time += days + ' д. ';
            else if (days >= 11 && days <= 14) {
              time += days + ' дней ';
            } else if (l == 1) {
              time += days + ' день ';
            } else if (l > 0 && l < 5) {
                time += days + ' дня ';
            } else {
              time += days + ' дней ';
            }
          }
          hours = parseInt(seconds / 3600);
          seconds -= hours * 3600;
          if (hours > 0 && years == 0 && days < 3) time += hours + ' ч. ';
        }
        mins = parseInt(seconds / 60);
        seconds -= mins * 60;
        if (years == 0 && days == 0 &&  mins > 0 && hours < 12) time += mins + ' мин. ';
        if (!hide_sec) {
          if (days == 0 && hours == 0 && mins < 30) {
            let s = parseInt(seconds);
            if (s < 0) s = 0;
            if (s) {
              time += (s + ' сек.');
            }
          }
        }
      } else {
        if (hide_sec) time = 'менее минуты';
        else {
          let s = parseInt(seconds);
          if (s < 0) s = 0;
          if (s) {
            time += (s + ' сек.');
          }
        }
      }
      return time;
    },
  },
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

.vs-input-number .vs-input-number--input {
  min-width: initial;
  padding: initial;
}

.datetime-input {
  width: 160px;
  margin: 0 5px;
  margin-bottom: 5px;
}
.ckeck-enable {
  margin: 0 5px;
}

.status-enable, .status-connect {
  margin: 8px;
  min-width: 110px;
  height: 32px;
  width: 32px;
  border-radius: 16px;
}
.vs-switch--circle {
  width: 22px;
height: 22px;
left: 4px;
top: 4px;
}
.vs-switch.vs-switch-active .vs-switch--circle {
    margin-left: calc(100% - 30px);
}

.vs-switch--text.text-on {
  padding-left: 10px;
}
.vs-switch--text.text-off {
  padding-right: 8px;
}

.vs-switch--circle {
  top: 5px;
}

// .vs-switch-success {
//   background: rgb(234,84,85)
// }

.status-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}

#page-device-view {
  table {
    td {
      vertical-align: top;
      min-width: 175px;
      padding-bottom: .2rem;
      word-break: break-all;
      padding-right: 10px;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }
}

</style>
